// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reelCapacityCalculatorStyles } from "@awc/App/Widgets/ReelCapacityCalculator/ReelCapacityCalculator";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, sharedCustomerToolsTableStyles, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

reelCapacityCalculatorStyles.diameterTextField = {
    cssOverrides: {
        formInputWrapper: css`
            max-width: 300px;
        `,
    },
};

reelCapacityCalculatorStyles.resultsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
        max-width: 100%;
    `,
};

reelCapacityCalculatorStyles.resultsText = {
    variant: "h2",
};

reelCapacityCalculatorStyles.infoText = {
    variant: "p",
};

reelCapacityCalculatorStyles.diameterText = {
    weight: fontConfig.weight.bold,
    color: "common.ui14",
};

reelCapacityCalculatorStyles.resultsTable = {
    css: css`
        ${sharedCustomerToolsTableStyles.css}
        &&& td {
            span {
                color: ${color("common.ui29")};
            }
        }
    `,
    mergeCss: true,
    cssOverrides: {
        wrapper: css`
            margin-bottom: 15px;
            display: flex;
            justify-content: center;

            ${xScreen("lte", "md")} {
                justify-content: flex-start;
            }
        `,
    },
};
